import z from "zod";

export const getPlanCheckDateSchema = z.object({
	date: z.string(),
});

export type GetPlanCheckDateSchema = z.infer<typeof getPlanCheckDateSchema>;
